import React, { Component } from "react";
import { View } from "react-native";
import { connect } from "react-redux";
import { getNextActionRequest } from "@microdoing/shared/services/action/actions";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import AlgoliaSearch from "./AlgoliaSearch";
import theme from "app/Theme/Theme";

class DirectoryScreen extends Component {
  navigateExternalProfile = id => () => {
    if (id === this.props.userId) {
      this.props.navigation.navigate("Profile");
    } else if (id) {
      this.props.requestExternalUser({ userId: id });
    }
  };

  render() {
    return (
      <View style={styles.main} testID="search-screen">
        <AlgoliaSearch navigation={this.props.navigation} autoFocus={false} />
      </View>
    );
  }
}

const styles = {
  main: {
    flex: 1,
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors["neutral.white"],
  },
};

const mapStateToProps = state => {
  const { title, category, how, why, gain } = state.action.action;
  const { nextCategory } = state.action;
  const { client } = state.user;
  return {
    userId: getUserId(state),
    categories: state.user.categories,
    historical: state.user.historical,
    actionId: state.action.action._id,
    nextCategory,
    client,
    title,
    category,
    how,
    why,
    gain,
    searchText: state.search.searchText,
  };
};

export default connect(mapStateToProps, {
  getNextActionRequest,
  requestExternalUser,
})(DirectoryScreen);
